import { Tipo_autorizacion } from './../../../models/tipo_autorizacion.model';
import { Component, OnInit } from "@angular/core";

@Component({
    selector: "page-tipo_autorizacion",
    templateUrl: "./tipo_autorizacion.component.html",
    styleUrls: ["./tipo_autorizacion.component.css"]

})


export class Tipo_autorizacionComponent implements OnInit {
    public rows = [];
    public actualRow;
    public tipo_autorizacion: Tipo_autorizacion;
    public form;
    public n_form
    public autorizacion = { "DEMOLICION": false, "MODIFICACION": false, "OBRA PRELIMINAR": false }
    constructor() {
        if (!JSON.parse(localStorage.getItem("tipo_autorizacion"))) {
            console.log("nuevo")
            localStorage.setItem("tipo_autorizacion", JSON.stringify(this.rows));
        } else {
            console.log("desde borrador");
            this.rows = JSON.parse(localStorage.getItem("tipo_autorizacion"));
            this.autorizacion = {

                "DEMOLICION": this.rows[0].autorizacion["DEMOLICION"] == true ? true : false,
                "MODIFICACION": this.rows[0].autorizacion["MODIFICACION"] == true ? true : false,
                "OBRA PRELIMINAR": this.rows[0].autorizacion["OBRA PRELIMINAR"] == true ? true : false,

            }
        }
    }

    ngOnInit() {
        this.n_form = localStorage.getItem("form");
        console.log("Form", this.n_form)
    }

    add_tipo_autorizacion() {

        localStorage.setItem("tipo_autorizacion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_autorizacion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            autorizacion: this.autorizacion


        })
        localStorage.setItem("tipo_autorizacion", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_autorizacion")));
    }

    delete_tipo_autorizacion(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_autorizacion", JSON.stringify(this.rows));
            }
        }
    }
}